import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Dropdown} from './Dropdown';
import {DarkModeToggle} from '../ui';
import {UserMenu} from './UserMenu';

export const Navbar: React.FC = () => {
    const navigate = useNavigate();

    const recordsItems = [
        {label: 'Shippers', onClick: () => navigate('/shippers')},
        {label: 'Consignees', onClick: () => navigate('/consignees')},
        {label: 'Ports', onClick: () => navigate('/ports')},
        {label: 'Shipping Lines', onClick: () => navigate('/shipping-lines')},
        {label: 'Makes', onClick: () => navigate('/makes')},
        {label: 'Models', onClick: () => navigate('/models')},
        {label: 'Companies', onClick: () => navigate('/companies')},
        {label: 'Insurance Prices', onClick: () => navigate('/insurance-prices')},
    ];

    const vehiclesItems = [
        {label: 'Total Voyages', onClick: () => navigate('/voyages')},
        {label: 'Total Bookings', onClick: () => navigate('/bookings')},
        {label: 'Total Cars', onClick: () => navigate('/total-cars')},
        {label: 'Change Voyage Chassis Number', onClick: () => navigate('/change-voyage-chassis')},
        {label: 'Bulk Change Voyage', onClick: () => navigate('/bulk-change-voyage')},
        {label: 'Bulk Add Line Meter', onClick: () => navigate('/bulk-line-meter')},
    ];

    const printingItems = [
        {label: 'Parking List', onClick: () => navigate('/print/parking-list')},
        {label: 'Loading List', onClick: () => navigate('/loading-list')},
        {label: 'Manifest', onClick: () => navigate('/freight-manifest')},
        {label: 'Bill of Lading', onClick: () => navigate('/bill-of-lading')},
        {label: 'Invoice', onClick: () => navigate('/invoice')},
        {label: 'Booking Confirmation', onClick: () => navigate('/booking-confirmation')},
    ];

    const archiveItems = [
        {label: 'Archived Voyages', onClick: () => navigate('/archived-voyages')},
        {label: 'Archived Bookings', onClick: () => navigate('/archived-bookings')},
        {label: 'Archived Cars', onClick: () => navigate('/archived-cars')},
    ];

    return (
        <nav className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <div className="flex items-center">
                        <div
                            className="flex-shrink-0 flex items-center cursor-pointer hover:opacity-80 transition-opacity duration-150"
                            onClick={() => navigate('/')}
                        >
                            <h1 className="text-2xl font-bold text-primary-600 dark:text-primary-400">FMS</h1>
                            <span className="ml-2 text-sm text-gray-500 dark:text-gray-400 hidden sm:block">
                Freight Management System
              </span>
                        </div>
                    </div>

                    {/* Navigation Menu */}
                    <div className="flex items-center space-x-4 relative">
                        <Dropdown title="Records" items={recordsItems}/>
                        <Dropdown title="Vehicles" items={vehiclesItems}/>
                        <Dropdown title="Printing" items={printingItems}/>
                        <Dropdown title="Archive" items={archiveItems}/>
                    </div>

                    {/* User Menu */}
                    <div className="flex items-center space-x-4">
                        <DarkModeToggle/>
                        <UserMenu/>
                    </div>
                </div>
            </div>
        </nav>
    );
};
